// alternative-dashboard/mappers/monthlyCashflowMapper.ts
import type { DashboardAccountsMonthlyCashflowResponse } from "@/app/types/alterNativeDashboardLayout";
export interface MonthlyCashflowChartPoint {
  name: string;
  inflow: number;
  outflow: number;
  net: number;
}

export const mapMonthlyCashflowToChartPoints = (
  raw: DashboardAccountsMonthlyCashflowResponse[] | undefined,
): MonthlyCashflowChartPoint[] => {
  if (!raw) return [];

  return raw.map((item) => ({
    name: item.month,
    inflow: item.inflows,
    outflow: item.outflows,
    net: item.netPosition,
  }));
};
